module.exports = __webpack_public_path__ + "static/media/points.08607537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/points.png
// module id = 693
// module chunks = 0